import type { NavItem } from '../use-nav-items'
import type { TranslateFn } from './types'

export function buildCrafts3DMenuItem(t: TranslateFn): NavItem {
  return {
    id: '3d',
    name: t('navigation.3d.3d'),
    link: '/3d-svg/',
    subMenuItems: [
      {
        id: '3d_crafts_paper_cut',
        name: t('navigation.3d.3d'),
        link: '/3d-svg/',
        wrapItems: true,
        trending: {},
        subMenuItems: [
          {
            name: t('navigation.3d.paper_cut.animals'),
            link: '/subscriptions/3d-svg/animals-3d-svg/',
          },
          {
            name: t('navigation.3d.paper_cut.baby'),
            link: '/subscriptions/3d-svg/baby-3d-svg/',
          },
          {
            name: t('navigation.3d.paper_cut.countries_travel'),
            link: '/subscriptions/3d-svg/countries-and-travel-3d-svg/',
          },
          {
            name: t('navigation.3d.paper_cut.flowers'),
            link: '/subscriptions/3d-svg/flowers-3d-svg/',
          },
          {
            name: t('navigation.3d.paper_cut.greeting_cards'),
            link: '/subscriptions/3d-svg/greeting-cards/',
          },
          {
            name: t('navigation.3d.paper_cut.holiday'),
            link: '/subscriptions/3d-svg/holidays-3d-svg/',
          },
          {
            name: t('navigation.3d.paper_cut.home_decor'),
            link: '/subscriptions/3d-svg/home-decor-3d-svg/',
          },
          {
            name: t('navigation.3d.paper_cut.kids'),
            link: '/subscriptions/3d-svg/kids-crafts-3d-svg/',
          },
          {
            name: t('navigation.3d.paper_cut.kids_crafts'),
            link: '/subscriptions/3d-svg/kids-crafts-3d-svg/',
          },
          {
            name: t('navigation.3d.paper_cut.life_events_celebrations'),
            link: '/subscriptions/3d-svg/life-events-and-celebrations-3d-svg/',
          },
          {
            name: t('navigation.3d.paper_cut.lifestyle_hobbies'),
            link: '/subscriptions/3d-svg/lifestyle-and-hobbies-3d-svg/',
          },
          {
            name: t('navigation.3d.paper_cut.paper_sculptures'),
            link: '/subscriptions/3d-svg/paper-sculptures-3d-svg/',
          },
          {
            name: t('navigation.3d.paper_cut.religious'),
            link: '/subscriptions/3d-svg/religious-3d-svg/',
          },
          {
            name: t('navigation.3d.paper_cut.seasons'),
            link: '/subscriptions/3d-svg/seasons-3d-svg/',
          },
          {
            name: t('navigation.3d.paper_cut.remembrance'),
            link: '/subscriptions/3d-svg/remembrance-3d-svg/',
          },
          {
            name: t('navigation.3d.paper_cut.wedding'),
            link: '/subscriptions/3d-svg/wedding-3d-svg/',
          },
          {
            name: t('navigation.3d.paper_cut.browse_all'),
            link: '/3d-svg/',
            isFootOption: true,
          },
        ],
      },
    ],
  }
}
